import { render } from "./table.component.vue?vue&type=template&id=502a990b"
import script from "./table.component.vue?vue&type=script&lang=js"
export * from "./table.component.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./table.component.vue?vue&type=style&index=0&id=502a990b&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd,QSelect,QSpace,QPagination});
